import React from "react";
import { Helmet } from "react-helmet";

const MarkDocs = () => (
  <div className="detail-page-post">
    <Helmet>
      <link rel="canonical" href="https://vektor.club/mark-docs" />
    </Helmet>

    <div className="detail-page-post-title">
      <h1 className="h1">Информация по товарному знаку</h1>
    </div>
    <div className="detail-page-post-content">
      <div className="detail-text">
        <p>
          <a href="/docs/Решение о регист. товарного знака.pdf" target="_blank" rel="noopener noreferrer">Решение о регистрации товарного знака</a> <br />
          <a href="/docs/товарный знак.pdf" target="_blank" rel="noopener noreferrer">Товарный знак</a>
        </p>
      </div>
    </div>
  </div>
);

export default MarkDocs;